// UI Colors
export const gray1 = '#F5F5F5'

export const blue = '#056171'
export const white = '#fff'
export const snow = '#FBFBFB'
export const black = '#000'
export const gainsboro = '#DEDEDE'
export const athensGray = '#EBEBEF'
export const whisper = '#EAEAEA'
export const alabaster = '#F9F9F9'
export const superSilver = '#EEEEEE'
export const doveGray = '#6B6B6B'
export const matterhorn = '#575757'
export const steelGray = '#454749'
export const whiteSmoke = '#F1F1F1'
export const red = 'red'

// Status colors
export const successGreen = '#49852E'
export const successGreenLight = '#D6ECD2'
export const errorRed = '#933B27'
export const errorRedLight = '#F5D3CE'

// Bottle colors
export const blazingYellow = '#F6E63E'
export const aquaSky = '#7FCACB'
export const vibrantGreen = '#5DAB63'
export const peachCream = '#F5A8A5'
export const driedHerb = '#8A8061'
export const cameoPink = '#DCABBA'
export const acacia = '#DCD067'
export const mistiPink = '#EDD5E2'
export const carmineRose = '#DB6393'
export const mistiCeleste = '#b9d5de'
export const superBlack = '#2D2926'
export const silverMist = '#D0D3D4'
export const blancDeBlanc = '#E9E9E7'
export const chestnut = '#8F6E5D'
export const blueGranite = '#77798E'
export const parachutePurple = '#504363'
export const desertFlower = '#FF9A90'
export const moltenLava = '#BD3D3A'
export const hauteRed = '#A42F3B'
export const poinciana = '#C94235'
export const boysenberry = '#893E62'
export const gloxinia = '#63385E'
export const grapeJuice = '#682961'
